import { Text, Link } from '@react-pdf/renderer';

// Simple parser for <a> tags (for well-formed, simple HTML strings)
const parseHtmlWithLinks = (html) => {
  const parts = [];
  // This regex matches <a href="...">...</a> with optional attributes like target
  const regex = /<a\s+[^>]*href="(.*?)"[^>]*>(.*?)<\/a>/gi;

  let lastIndex = 0;
  let match;

  while ((match = regex.exec(html)) !== null) {
    const [fullMatch, href, linkText] = match;

    // Add any text before the link
    if (match.index > lastIndex) {
      parts.push({
        type: 'text',
        content: html.substring(lastIndex, match.index),
      });
    }

    // Add the link
    parts.push({
      type: 'link',
      content: linkText,
      href,
    });

    lastIndex = regex.lastIndex;
  }

  // Add remaining text after last link
  if (lastIndex < html.length) {
    parts.push({
      type: 'text',
      content: html.substring(lastIndex),
    });
  }

  return parts;
};

const HtmlText = ({ html, style }) => {
  const parsed = parseHtmlWithLinks(html);

  return (
    <Text style={style}>
      {parsed.map((part, index) => {
        if (part.type === 'link') {
          return (
            <Link key={index} src={part.href} style={{ color: 'blue', textDecoration: 'underline' }}>
              {part.content}
            </Link>
          );
        }
        return <Text key={index}>{part.content}</Text>;
      })}
    </Text>
  );
};

export default HtmlText;